import React from "react"
import { Dropdown, Grid } from "semantic-ui-react"
import { useStore } from "store"

export const AccountRow = ({
  id: accountId,
  ignoreConnection,
  unignoreConnection
}) => {
  const [connection] = useStore("connections", accountId)
  const { type, description, id } = connection
  return (
    <Grid.Row columns="equal" className="ConnectedAccount__Row">
      <Grid.Column className={`LinkedAccount__${type}`}>
        <p>
          {`${description.split("--")[0]}`}{" "}
          <span style={{ textTransform: "uppercase" }}>
            (
            {description
              .split("--")[1]
              .split(" ")[1]
              .split("_")
              .join(" ")
              .toLowerCase()}
            )
          </span>
        </p>
      </Grid.Column>
      <Grid.Column textAlign="right" className="ConnectedAccount__Status">
        {type === "unsupported" ? (
          <span style={{ textTransform: "capitalize", color: "#ababab" }}>
            {type}
          </span>
        ) : (
          <Dropdown text={type === "account" ? "Active" : type}>
            <Dropdown.Menu>
              {type === "ignored" ? (
                <Dropdown.Item
                  text="Unignore"
                  onClick={() => unignoreConnection(id)}
                />
              ) : (
                <Dropdown.Item
                  text="Ignore"
                  onClick={() => ignoreConnection(id)}
                />
              )}
            </Dropdown.Menu>
          </Dropdown>
        )}
      </Grid.Column>
    </Grid.Row>
  )
}
